import type { HttpError } from '@refinedev/core';
import axios from 'axios';

export const createApiClient = () => {
  const axiosInstance = axios.create({
    // Send the httpOnly session cookie with every request
    withCredentials: true,
  });

  axiosInstance.interceptors.response.use(
    response => response,
    async error => {
      const customError: HttpError = {
        ...error,
        message: error.response?.data?.message,
        statusCode: error.response?.status,
      };

      return Promise.reject(customError);
    },
  );

  return axiosInstance;
};

export const axiosInstance = createApiClient();
